import {Component, Input, Output, EventEmitter} from '@angular/core';
import {FaqCategory} from '../../../model/FaqCategory';
import {NgbDate} from '@ng-bootstrap/ng-bootstrap';
import {Event} from '../../../model/Event';
import {FormGroup} from "@angular/forms";
import {FaIconComponent} from "@fortawesome/angular-fontawesome";

import {DynamicModalFormComponent} from "../../../components/common/dynamic-modal-form/dynamic-modal-form.component";
import {EventFormGeneratorService} from "../../../formulaires/admin/event-form-generator.service";
import {FieldDefinition} from "../../../model/field-definition";

@Component({
    selector: 'app-create-event-action',
    templateUrl: './create-event-action.component.html',
    styleUrls: ['./create-event-action.component.css'],
    imports: [
    DynamicModalFormComponent,
    FaIconComponent
]
})
export class CreateEventActionComponent {
  @Input()
  categories: FaqCategory[];

  @Input()
  event: Event;
  @Output()
  eventChange = new EventEmitter<Event>();

  constructor(public eventFormGeneratorService: EventFormGeneratorService) {
  }

  createNewEvent(): void {
    this.event = new Event();
  }

  save($event): void {
    this.eventChange.emit({...this.event, ...$event});
  }

  onChangedForm(values: Event, form: FormGroup, questions: FieldDefinition<any>[]) {
    if (values.beginDate) {
      if (values.endDate) {
        if (new Date(values.beginDate).getTime() >= new Date(values.endDate).getTime()) {
          form.patchValue({'endDate': undefined});
        }
      }
      const d = new Date(values.beginDate);
      d.setDate(d.getDate() + 1);
      questions.find((q) => q.key === 'endDate').payload = new NgbDate(d.getFullYear(), d.getMonth() + 1, d.getDate());
    }
  }
}
